import request from '@shared/api/request';
import {
    API_SCHEMES_PATH,
    API_STANDS_PATH,
    API_TEST_CASE_PATH,
    API_TEST_PLAN_PATH,
    API_BUILDS,
    API_TEST_RUN_PATH,
} from '@shared/constants/pathsConstants';
import {
    DeployEntityRequestParams,
    GetBranchesParams,
    Stand,
    StandBranch,
    StandEntityType,
    UpdateVMByStandIdRequestParams,
} from '@pages/stands/types';
import { AxiosResponse } from 'axios';
import { PaginatedList } from '@shared/types';
import { DeployEntityResponse } from '@pages/stands/store';
import { Scheme } from '@pages/schemes/types';

const MAP_ENTITY_TO_URL: Record<StandEntityType, string> = {
    scheme: API_SCHEMES_PATH,
    testcase: API_TEST_CASE_PATH,
    testplan: API_TEST_PLAN_PATH,
};

export function startEntityDeploy({
    type,
    id,
    params,
}: DeployEntityRequestParams): Promise<AxiosResponse<DeployEntityResponse>> {
    const getPayloadObject = (paramsObj: typeof params) => {
        if (typeof paramsObj === 'object') {
            const { testrunId, ...restParams } = paramsObj;

            return {
                ...restParams,
                testrun_id: testrunId,
            };
        }
        return {};
    };

    return request.post(`/${MAP_ENTITY_TO_URL[type]}/apistand/`, {
        id,
        ...getPayloadObject(params),
    });
}

export function destroyStand(id: Stand['pk']): Promise<AxiosResponse<void>> {
    return request.delete(`/${API_STANDS_PATH}/${id}/`);
}

export function updateStand(id: Stand['pk'], data: Partial<Stand>): Promise<AxiosResponse<Stand>> {
    if (data.allowed_users) {
        return request.patch(`/${API_STANDS_PATH}/${id}/permissions/`, { allowed_users: data.allowed_users });
    }

    return request.patch(`/${API_STANDS_PATH}/${id}/`, data);
}
export function getStands(params: any): Promise<AxiosResponse<{ items: Stand[]; count: number }>> {
    return request.get(`/${API_STANDS_PATH}/`, {
        params: {
            ...params,
            page_index: params?.page_index + 1,
        },
    });
}

export function getStand(id: Stand['pk']): Promise<AxiosResponse<Stand>> {
    return request.get(`/${API_STANDS_PATH}/${id}/detail/`);
}

export function getDeployedSchemesForEntity(entity: StandEntityType, id: number): Promise<AxiosResponse<Scheme[]>> {
    const resultEntity = entity === 'testcase' ? 'testcasemodel' : entity;
    return request.get(`/entities/${resultEntity}/${id}/`);
}

export function getBranchesForDeploy(params: GetBranchesParams): Promise<AxiosResponse<PaginatedList<StandBranch>>> {
    return request.get(`/ci/branches/`, { params });
}

export function getBuildsForDeploy(branchName: string) {
    return branchName
        ? request.get(`/ci/builds/`, { params: { branchName } })
        : request.get(`/${API_TEST_RUN_PATH}/${API_BUILDS}/`);
}

export function getBuildDetails(branchName: string, buildNumber: string) {
    return request.get(`/ci/build-details/`, { params: { branchName, buildNumber } });
}

export function updateVMByStandId({ pk, name, data }: UpdateVMByStandIdRequestParams) {
    return request.patch(`/${API_STANDS_PATH}/${pk}/vms/${name}`, data);
}

export function getStandsBuilds(branch?: string) {
    return request.get(`/${API_STANDS_PATH}/builds/`, {
        params: branch ? { branch } : undefined,
    });
}

export function getStandsBranches() {
    return request.get(`/${API_STANDS_PATH}/branches/`);
}
